import { useContext, useEffect } from 'react';
import { AppSettings } from '../config/app-settings.js';

export function useAuthPageLayout() {
	const settings = useContext(AppSettings);

	useEffect(() => {
		// acontece quando o componente é montado
		settings.handleSetAppSidebarNone(true);
		settings.handleSetAppHeaderNone(true);
		settings.handleSetAppContentClass('p-0');

		//acontece quando o componente é desmontado
		return () => {
			settings.handleSetAppSidebarNone(false);
			settings.handleSetAppHeaderNone(false);
			settings.handleSetAppContentClass('');
		}
	}, []);

	return settings;
}